"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _angieslistReactComponents = require("angieslist-react-components");
var CertifiedPopOver = function CertifiedPopOver(props) {
  return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Popover, (0, _extends2["default"])({
    id: "popover-certified-badge",
    className: "popover-certified-badge"
  }, props), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Angi Certified Businesses")), /*#__PURE__*/_react["default"].createElement("p", null, 'These Businesses meet our standards of certification, which include:'), /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "The owner, principal, or relevant manager passing a criminal background check"), /*#__PURE__*/_react["default"].createElement("li", null, "Required to have applicable state and local licenses"), /*#__PURE__*/_react["default"].createElement("li", null, "Maintain an average star rating of 3.0 or better on our network, if they have at least one review"), /*#__PURE__*/_react["default"].createElement("li", null, "Paying to advertise their services"), /*#__PURE__*/_react["default"].createElement("li", null, "Meeting any other eligibility criteria required by Angi "))));
};
var _default = exports["default"] = CertifiedPopOver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/certifiedPopOver.js
// module id = 1711
// module chunks = 25